module.exports = __webpack_public_path__ + "media/images/riders/CATHARINE_PENDREL-c6467f9447f70dc78c03ba0ae4466163.png";